import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function MycotoxinAdsorbents(props) {
  return (
    <>
      <Row>
        <Col>
          <div
            style={{
              textAlign: "end",
              marginRight: "40px",
            }}
          >
            <Input
              type="checkbox"
              params="additions.mycotoxinAdsorbents.unknownConcept"
              item={props.broiler}
              setItem={props.setBroiler}
              label="Cliente não conhece o conceito"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual Produto?</span>
                </th>
                <th>
                  <span>Qual Finalidade?</span>
                </th>
                <th>
                  <span>Qual Dose?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.pre.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.pre.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.pre.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Inicial</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.initial.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.initial.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.initial.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 1</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 2</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth2.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth2.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.growth2.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Final</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.final.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.final.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.mycotoxinAdsorbents.final.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
    </>
  );
}
